// Hacking HR Shop theme interactions.
// Variant picker, gallery, AJAX cart drawer, cart line updates, filters and recommendations.

(function () {
  var theme = window.theme || { routes: {}, cartType: 'drawer' };
  var routes = theme.routes;

  // ---------- Helpers ----------
  function formatMoney(cents) {
    var format = theme.moneyFormat || '${{amount}}';
    var value = (cents / 100);
    function withDelimiters(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimals ? decimal : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_space_separator': return withDelimiters(value, 2, ' ', ',');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  function sectionHTML(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.firstElementChild;
  }

  function closestSectionId(el) {
    var wrap = el && el.closest('.shopify-section');
    return wrap ? wrap.id.replace('shopify-section-', '') : null;
  }

  // ---------- Header height, so the hero can fill exactly the rest of the screen ----------
  function setHeaderHeight() {
    var h = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (s) { h += s.offsetHeight; });
    document.documentElement.style.setProperty('--header-h', h + 'px');
  }
  setHeaderHeight();
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(setHeaderHeight);
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (s) { ro.observe(s); });
  } else {
    window.addEventListener('resize', setHeaderHeight);
  }

  // ---------- Announcement bar: rotate messages on small screens ----------
  document.querySelectorAll('[data-announce]').forEach(function (bar) {
    var items = bar.children;
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    var timer = setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
    bar.addEventListener('mouseenter', function () { clearInterval(timer); });
  });

  // ---------- Close open <details> menus on outside click / Escape ----------
  var closableDetails = '.nav-dropdown, .header-search, .mobile-menu, .filter';
  document.addEventListener('click', function (e) {
    document.querySelectorAll(closableDetails).forEach(function (d) {
      if (d.open && !d.contains(e.target)) d.open = false;
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(closableDetails).forEach(function (d) {
      if (d.open) { d.open = false; var s = d.querySelector('summary'); if (s) s.focus(); }
    });
    closeDrawer();
  });
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('.header-search') || !d.open) return;
    var input = d.querySelector('input[type="search"]');
    if (input) input.focus();
  }, true);

  // ---------- Predictive search (header) ----------
  function escapeHTML(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  document.querySelectorAll('[data-predictive-input]').forEach(function (input) {
    var panel = input.closest('.header-search-panel');
    var box = panel && panel.querySelector('[data-predictive]');
    if (!box || !routes.predictiveSearch) return;
    var timer = null;
    var controller = null;

    function clear() { box.hidden = true; box.innerHTML = ''; }

    function render(q, res) {
      var products = res.products || [];
      var collections = res.collections || [];
      var pages = res.pages || [];
      var html = '';
      if (products.length) {
        html += '<div class="predictive-group"><h3>Products</h3><ul>' + products.map(function (p) {
          var img = p.featured_image && p.featured_image.url
            ? '<img src="' + escapeHTML(p.featured_image.url) + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="56" height="56" loading="lazy">'
            : '<span class="predictive-thumb"></span>';
          var price = p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '';
          return '<li><a class="predictive-product" href="' + escapeHTML(p.url) + '">' + img +
            '<span class="predictive-title">' + escapeHTML(p.title) + '</span>' +
            '<span class="predictive-price">' + escapeHTML(price) + '</span></a></li>';
        }).join('') + '</ul></div>';
      }
      var links = collections.concat(pages);
      if (links.length) {
        html += '<div class="predictive-group"><h3>Collections &amp; pages</h3><ul>' + links.map(function (l) {
          return '<li><a class="predictive-link" href="' + escapeHTML(l.url) + '">' + escapeHTML(l.title) + '</a></li>';
        }).join('') + '</ul></div>';
      }
      if (!html) html = '<p class="predictive-empty">No matches for “' + escapeHTML(q) + '”.</p>';
      var all = (routes.search || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      html += '<a class="predictive-all link-arrow" href="' + all + '">See all results for “' + escapeHTML(q) + '”</a>';
      box.innerHTML = html;
      box.hidden = false;
    }

    function search(q) {
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=product,collection,page&resources%5Blimit%5D=5&resources%5Boptions%5D%5Bunavailable_products%5D=last';
      fetch(url, { headers: { Accept: 'application/json' }, signal: controller ? controller.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) {
          if (input.value.trim() !== q) return; // a newer query is on its way
          render(q, (data.resources && data.resources.results) || {});
        })
        .catch(function (err) { if (err.name !== 'AbortError') clear(); });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { if (controller) controller.abort(); clear(); return; }
      timer = setTimeout(function () { search(q); }, 200);
    });
  });

  // ---------- Cart drawer ----------
  var lastFocus = null;

  function drawer() { return document.querySelector('[data-cart-drawer]'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return false;
    lastFocus = document.activeElement;
    d.hidden = false;
    document.body.classList.add('drawer-open');
    var panel = d.querySelector('.cart-drawer-panel');
    if (panel) panel.focus();
    return true;
  }

  function closeDrawer() {
    var d = drawer();
    if (!d || d.hidden) return;
    d.hidden = true;
    document.body.classList.remove('drawer-open');
    if (lastFocus) lastFocus.focus();
  }

  function setCount(n) {
    n = parseInt(n, 10) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      var changed = el.textContent.trim() !== String(n);
      el.textContent = n;
      el.hidden = n === 0;
      var btn = el.closest('.cart-btn');
      if (btn) btn.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
      if (changed && n > 0) {
        el.classList.remove('is-bumped');
        void el.offsetWidth; // restart the animation
        el.classList.add('is-bumped');
      }
    });
  }

  // Replace rendered sections returned by the Section Rendering API.
  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var current = document.getElementById('shopify-section-' + id);
      var html = sections[id];
      if (!current || !html) return;
      var fresh = sectionHTML(html);
      if (!fresh) return;
      var wasOpen = id === 'cart-drawer' && drawer() && !drawer().hidden;
      current.replaceWith(fresh);
      if (wasOpen) {
        var d = drawer();
        d.hidden = false;
        var panel = d.querySelector('.cart-drawer-panel');
        if (panel) panel.focus();
      }
    });
    var source = document.querySelector('[data-cart-count-source]');
    if (source) setCount(source.textContent.trim());
  }

  function sectionsToRender(origin) {
    var ids = [];
    if (drawer()) ids.push('cart-drawer');
    var pageCart = document.querySelector('[data-cart-page]');
    var pageId = closestSectionId(pageCart);
    if (pageId) ids.push(pageId);
    var originId = closestSectionId(origin);
    if (originId && ids.indexOf(originId) === -1 && origin.closest('[data-cart-page]')) ids.push(originId);
    return ids;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener && theme.cartType === 'drawer' && drawer()) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  // Trap focus inside the open drawer
  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (e.key !== 'Tab' || !d || d.hidden) return;
    var focusables = d.querySelectorAll('a[href], button:not([disabled]), input, textarea, select, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // ---------- Cart line quantity changes (drawer and cart page) ----------
  function changeLine(line, quantity, origin) {
    var container = origin.closest('.cart-lines') || origin;
    container.classList.add('is-updating');
    fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity) || 0), sections: sectionsToRender(origin), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status && cart.description) throw new Error(cart.description);
        setCount(cart.item_count);
        if (cart.item_count === 0 && document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
        applySections(cart.sections);
      })
      .catch(function () { window.location.reload(); })
      .finally(function () { container.classList.remove('is-updating'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    changeLine(btn.dataset.lineChange, btn.dataset.qty, btn);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-input]');
    if (!input) return;
    changeLine(input.dataset.lineInput, input.value, input);
  });

  // ---------- Product page ----------
  function initProduct(root) {
    var form = root.querySelector('[data-product-form]');
    var jsonEl = root.querySelector('[data-product-json]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-price]');
    var errorEl = root.querySelector('[data-form-error]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var main = root.querySelector('[data-gallery-main]');
    var sticky = document.querySelector('[data-sticky-buy]');
    // An empty variant id means a required option (apparel size) hasn't been picked yet
    var current = idInput && !idInput.value ? null
      : variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || variants[0];

    function qty() { return qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1; }

    function needsChoice() {
      return Array.prototype.some.call(root.querySelectorAll('[data-option-required]'), function (fs) {
        return !fs.querySelector('input:checked');
      });
    }

    function showMedia(id) {
      if (!main || !id) return;
      var slide = main.querySelector('[data-media-id="' + id + '"]');
      if (!slide) return;
      main.querySelectorAll('.gallery-slide').forEach(function (s) { s.classList.toggle('is-active', s === slide); });
      root.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('aria-pressed', t.dataset.thumb === String(id) ? 'true' : 'false'); });
    }

    function renderButton() {
      if (!addBtn) return;
      addBtn.classList.remove('is-added');
      if (!current) {
        // Left enabled so a tap explains what's missing instead of doing nothing
        addBtn.disabled = !needsChoice();
        addBtn.textContent = needsChoice() ? 'Select a size' : 'Unavailable';
      } else {
        addBtn.disabled = !current.available;
        addBtn.textContent = current.available ? 'Add to cart · ' + formatMoney(current.price * qty()) : 'Sold out';
      }
      var dynamicCheckout = root.querySelector('[data-dynamic-checkout]');
      if (dynamicCheckout) dynamicCheckout.hidden = !current || !current.available;
      renderSticky();
    }

    function renderPrice() {
      if (!priceEl || !current) return;
      var html = formatMoney(current.price);
      if (window.theme.showSalePrices && current.compare_at_price && current.compare_at_price > current.price) {
        html += ' <s class="compare">' + formatMoney(current.compare_at_price) + '</s>';
      }
      priceEl.innerHTML = html;
    }

    // Sticky phone bar mirrors the main button; "Select a size" scrolls up to the sizes instead
    function renderSticky() {
      if (!sticky || !addBtn) return;
      var btn = sticky.querySelector('[data-sticky-add]');
      var price = sticky.querySelector('[data-sticky-price]');
      if (current && price) price.textContent = formatMoney(current.price);
      btn.textContent = !current && needsChoice() ? 'Select a size' : (current && !current.available ? 'Sold out' : 'Add to cart');
      btn.disabled = !!current && !current.available;
    }

    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.hidden = entries[0].isIntersecting;
      }).observe(addBtn);
      sticky.querySelector('[data-sticky-add]').addEventListener('click', function () {
        if (!current && needsChoice()) { promptForChoice(); return; }
        if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
    }

    function promptForChoice() {
      var fs = root.querySelector('[data-option-required]');
      if (!fs) return;
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fs.classList.add('needs-choice');
      if (errorEl) { errorEl.textContent = 'Choose a size to add this to your cart.'; errorEl.hidden = false; }
      var first = fs.querySelector('input:not(:disabled)');
      if (first) first.focus({ preventScroll: true });
    }

    if (form) form.addEventListener('submit', function (e) {
      if (!current && needsChoice()) { e.preventDefault(); e.stopImmediatePropagation(); promptForChoice(); }
    });

    // Size guide pop-up: rebuild the description's chart (sizes as columns) as one row per size
    var sizeDialog = document.querySelector('[data-size-dialog]');
    var sizeOpen = root.querySelector('[data-size-guide-open]');
    if (sizeDialog && sizeOpen && sizeDialog.showModal) {
      var unit = 'in';
      var guide = null; // { sizes: [], measures: [{ label, values: [] }] }

      var readGuide = function () {
        var tpl = sizeDialog.querySelector('[data-size-source]');
        var table = tpl && tpl.content.querySelector('table');
        if (!table) return null;
        var rows = Array.prototype.map.call(table.rows, function (r) {
          return Array.prototype.map.call(r.cells, function (c) { return c.textContent.trim(); });
        });
        var sizes = rows[0].slice(1);
        var measures = rows.slice(1).map(function (r) {
          return { label: r[0].replace(/,?\s*in$/i, ''), values: r.slice(1).map(Number) };
        });
        // A measurement that's the same for every size (e.g. size tolerance) becomes a note
        var note = measures.filter(function (m) { return /toleran/i.test(m.label); })[0];
        return { sizes: sizes, measures: measures.filter(function (m) { return m !== note; }), note: note };
      };

      var fmt = function (n) {
        var v = unit === 'cm' ? n * 2.54 : n;
        return isNaN(v) ? '–' : (Math.round(v * 10) / 10).toString();
      };

      var renderGuide = function () {
        var sizeFs = sizeOpen.closest('fieldset');
        var pickedSize = sizeFs && sizeFs.querySelector('input:checked') ? sizeFs.querySelector('input:checked').value : null;
        var html = '<table><thead><tr><th scope="col">Size</th>' + guide.measures.map(function (m) {
          return '<th scope="col">' + m.label + ' <span class="unit">(' + unit + ')</span></th>';
        }).join('') + '</tr></thead><tbody>' + guide.sizes.map(function (s, i) {
          return '<tr' + (s === pickedSize ? ' class="is-picked"' : '') + '><th scope="row">' + s + '</th>' +
            guide.measures.map(function (m) { return '<td>' + fmt(m.values[i]) + '</td>'; }).join('') + '</tr>';
        }).join('') + '</tbody></table>';
        sizeDialog.querySelector('[data-size-table]').innerHTML = html;
        var noteEl = sizeDialog.querySelector('[data-size-note]');
        if (guide.note) {
          noteEl.textContent = 'Measurements can vary by up to ' + fmt(guide.note.values[0]) + ' ' + unit + '.';
          noteEl.hidden = false;
        }
        sizeDialog.querySelectorAll('[data-unit]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.unit === unit ? 'true' : 'false'); });
      };

      sizeOpen.addEventListener('click', function () {
        guide = guide || readGuide();
        if (!guide) return;
        renderGuide();
        sizeDialog.showModal();
      });
      sizeDialog.addEventListener('click', function (e) {
        var u = e.target.closest('[data-unit]');
        if (u) { unit = u.dataset.unit; renderGuide(); return; }
        // Close on the X or a click on the backdrop
        if (e.target.closest('[data-size-guide-close]') || e.target === sizeDialog) sizeDialog.close();
      });
    }

    // Long galleries: reveal the rest of the thumbnails
    var more = root.querySelector('[data-thumbs-more]');
    if (more) more.addEventListener('click', function () {
      more.closest('[data-thumbs]').classList.remove('is-collapsed');
      more.remove();
    });

    // Swipe the main image on touch screens
    if (main) {
      var startX = null;
      main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 40) return;
        var slides = Array.prototype.slice.call(main.querySelectorAll('.gallery-slide'));
        var i = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
        var next = slides[(i + (dx < 0 ? 1 : -1) + slides.length) % slides.length];
        if (next) {
          showMedia(next.dataset.mediaId);
          var thumb = root.querySelector('[data-thumb="' + next.dataset.mediaId + '"]');
          if (thumb) thumb.scrollIntoView({ block: 'nearest', inline: 'center' });
        }
      }, { passive: true });
    }

    function onOptionChange() {
      var selected = [];
      root.querySelectorAll('.option[data-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        selected[Number(fs.dataset.optionIndex)] = checked ? checked.value : null;
        var label = fs.querySelector('[data-option-label]');
        if (label && checked) label.textContent = checked.value;
      });
      current = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
      if (current) {
        idInput.value = current.id;
        if (current.featured_media) showMedia(current.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', current.id);
        window.history.replaceState({}, '', url.toString());
      } else {
        // No size picked yet: still show the photo for the chosen colour (first variant matching what is picked)
        var partial = variants.find(function (v) {
          return v.featured_media && v.options.every(function (o, i) { return selected[i] === null || o === selected[i]; });
        });
        if (partial) showMedia(partial.featured_media.id);
      }
      renderPrice();
      renderButton();
      if (errorEl) errorEl.hidden = true;
      root.querySelectorAll('.needs-choice').forEach(function (fs) { fs.classList.remove('needs-choice'); });
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('.option')) onOptionChange();
      if (e.target === qtyInput) renderButton();
    });

    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      if (step && qtyInput) {
        qtyInput.value = Math.min(99, Math.max(1, qty() + Number(step.dataset.qtyStep)));
        renderButton();
      }
      var thumb = e.target.closest('[data-thumb]');
      if (thumb) showMedia(thumb.dataset.thumb);
    });

    renderSticky();
    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (theme.cartType !== 'drawer' || !drawer()) return; // let the form post to /cart/add
      e.preventDefault();
      if (!current || !current.available) return;
      addBtn.classList.add('is-loading');
      addBtn.disabled = true;
      if (errorEl) errorEl.hidden = true;

      fetch(routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: current.id, quantity: qty() }],
          sections: 'cart-drawer',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.description) throw new Error(res.description);
          applySections(res.sections);
          addBtn.classList.add('is-added');
          addBtn.textContent = 'Added to cart';
          openDrawer();
          setTimeout(renderButton, 2500);
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message || 'Couldn’t add that to your cart. Please try again.'; errorEl.hidden = false; }
          renderButton();
        })
        .finally(function () {
          addBtn.classList.remove('is-loading');
          if (current && current.available) addBtn.disabled = false;
        });
    });
  }

  document.querySelectorAll('[data-product]').forEach(initProduct);

  // ---------- FAQ: filter by topic ----------
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-faq-topic]');
    if (!chip) return;
    var faq = chip.closest('[data-faq]');
    var topic = chip.dataset.faqTopic;
    faq.querySelectorAll('[data-faq-topic]').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
    faq.querySelectorAll('[data-faq-group]').forEach(function (g) { g.hidden = topic !== 'all' && g.dataset.faqGroup !== topic; });
  });

  // ---------- Newsletter: subscribe to the Hacking HR list ----------
  // If the request can't be made (network or CORS), fall back to the normal Shopify customer form.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-newsletter-endpoint]');
    if (!form || !form.dataset.newsletterEndpoint || form.dataset.fallback) return;
    e.preventDefault();
    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('[data-newsletter-button]');
    var note = form.querySelector('[data-newsletter-note]');
    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch(form.dataset.newsletterEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ email: input.value })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (res) {
          note.textContent = res.message || (r.ok ? 'You’re subscribed.' : 'We couldn’t subscribe you. Please try again.');
          if (r.ok && res.success) { form.classList.add('is-subscribed'); input.value = ''; input.removeAttribute('aria-invalid'); }
          else input.setAttribute('aria-invalid', 'true');
        });
      })
      .catch(function () {
        form.dataset.fallback = 'true';
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });

  // ---------- Add a whole kit to the cart ----------
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-all]');
    if (!form || theme.cartType !== 'drawer' || !drawer()) return; // otherwise the form posts to /cart/add
    e.preventDefault();
    var btn = form.querySelector('[data-add-all-button]');
    var errorEl = form.querySelector('[data-add-all-error]');
    var label = btn.textContent;
    var ids = form.querySelectorAll('input[name="items[][id]"]');
    var items = Array.prototype.map.call(ids, function (i) { return { id: Number(i.value), quantity: 1 }; });
    btn.disabled = true;
    btn.classList.add('is-loading');
    if (errorEl) errorEl.hidden = true;

    fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) throw new Error(res.description);
        applySections(res.sections);
        btn.textContent = 'Added to cart';
        openDrawer();
        setTimeout(function () { btn.textContent = label; }, 2500);
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message || 'Couldn’t add the kit to your cart. Please try again.'; errorEl.hidden = false; }
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  });

  // ---------- Product recommendations ----------
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  });

  // ---------- Collection sorting / filters ----------
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-auto-submit], [data-filter-form] .filter-panel input[type="checkbox"]');
    if (!el || !el.form) return;
    if (el.form.requestSubmit) el.form.requestSubmit(); else el.form.submit();
  });

  // Strip empty price-range inputs so URLs stay clean
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-filter-form]')) {
      form.querySelectorAll('input[type="number"]').forEach(function (i) { if (!i.value) i.disabled = true; });
    }
    if (form.dataset.confirm && !window.confirm(form.dataset.confirm)) e.preventDefault();
  });

  // ---------- Address forms: preselect country ----------
  document.querySelectorAll('select[data-default]').forEach(function (s) {
    if (s.dataset.default) s.value = s.dataset.default;
  });
})();
